import {Component, OnInit} from '@angular/core';

@Component({
     selector: 'ixprogressbar',
     templateUrl: './progressbar.component.html',
     styleUrls: ['./progressbar.component.css',
         '../../../../node_modules/bootstrap/dist/css/bootstrap.css']
})
export class ProgressbarComponent implements OnInit{
    progressValue: string = '0';
    progressText: string = '';
    showOnRight: boolean = true;
    // interval:any;

    resetProgress() {
        this.progressValue = '0';
        this.progressText = '';
        this.showOnRight = true;

    }

    updateProgress(value: number, text: string) {
        if(value>50) {
          this.showOnRight = false;
        }
        else {
          this.showOnRight = true;
        }
        if(value <= 100){
          this.progressValue = String(value);
        }else{
          this.progressValue = String(100);
        }

        this.progressText = text;
    }

    ngOnInit() {
        /*this.interval = setInterval(() => {
            var progNum = +this.progressValue;
            this.progressValue = String(progNum + 1);
            this.progressText = this.progressValue;
        }, 1000 );*/
    }

}



// WEBPACK FOOTER //
// ./src/app/components/progressbar/progressbar.component.ts